<template>
	<b-modal :no-close-on-backdrop="isLoading" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary editHotelHrambaModal" @hidden="clearModalData">
		<loading :active.sync="isLoading" 
			:is-full-page="false"></loading>
		<b-row v-if="mode === mode_ADDING1 || mode === mode_EDITING2">
			<b-col>
				<b-card>
					<div slot="header">
						<div class="card-actions">
							<b-link v-if="userCanEdit" title="Dodaj stranko" @click.stop="hotelStrankaAdding_click" class="card-header-action btn-setting"><i class="icon-plus"></i></b-link>
						</div>
						Stranka
					</div>
					<b-form-group
						label-for="input-fk_hotel_stranka">
						<v-select ref="hotelStranke"
							v-model="hotel_stranka_selected"
							:options="all_hotelStranke"
							label="title"
							@input="hotelStrankeSelect_change"
							@search="hotelStrankeSelect_search"
							placeholder="Izberi stranko ..."
							:disabled="!userCanEdit">
							<template slot="no-options">Kupec ni najden</template>
						</v-select>
					</b-form-group>
					<div v-if="hotel_stranka_selected.id > 0">
						<b-row class="mb-2">
							<b-col>
								<b-button disabled class="noPointer" variant="primary">{{ hotel_stranka_selected.external ? 'External' : 'Internal' }}</b-button>
							</b-col>
							<b-col>
								<b-button disabled class="noPointer" variant="primary">{{ hotel_stranka_selected.is_company ? 'Podjetje' : 'Fizična oseba' }}</b-button>
							</b-col>
						</b-row>
						<b-row v-if="hotel_stranka_selected.is_company">
							<b-col>
								<b-form-group label="Naziv:"
									label-for="kupec_title">
									<b-form-input
										type="text"
										v-model="hotel_stranka_selected.title"
										disabled></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row v-else>
							<b-col>
								<b-form-group label="Ime:"
									label-for="kupec_ime">
									<b-form-input
										type="text"
										v-model="hotel_stranka_selected.first_name"
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group label="Priimek:" 
									label-for="kupec_priimek">
									<b-form-input
										type="text"
										v-model="hotel_stranka_selected.last_name"
										disabled></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<b-form-group label="Email:"
									label-for="kupec_email">
									<b-form-input
										type="text"
										v-model="hotel_stranka_selected.email"
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group label="Telefonska številka:" 
									label-for="kupec_telefon">
									<b-form-input
										type="text"
										v-model="hotel_stranka_selected.phone_number"
										disabled></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<b-form-group
									label-for="input-vehicle"
									label="Vozilo:">
										<b-form-input 
										disabled v-model="hotel_stranka_selected.vehicle"></b-form-input>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group
									label-for="input-registration_number"
									label="Registrska številka:">
										<b-form-input
										disabled v-model="hotel_stranka_selected.registration_number" ></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
					</div>
					<div class="text-right">
						<b-button v-if="hotel_stranka_selected.id > 0" :disabled="hotelStrankaEditButoon.disabled || !userCanEdit" variant="warning" @click.stop="hotelStrankaEdit_click()">{{ hotelStrankaEditButoon.label }}
							<b-spinner small v-if="hotelStrankaEditButoon.progress"></b-spinner>
						</b-button>
					</div>
				</b-card>
				<b-card>
					<div slot="header">
						Lokacija
					</div>
					<b-form-group
						label-for="input-fk_hotel_lokacija"
						:valid-feedback="feedback_lokacija"
						:state="state_lokacija">
						<v-select
							v-model="selectedLocation"
							ref="hotelLokacije"
							:options="hotelLokacije_options"
							label="title"
							@input="hotelLokacijeSelect_change"
							@search="hotelLokacijeSelect_search"
							:taggable="true"
							:filterable="false"
							placeholder="Izberi lokacijo ..."
							:disabled="!userCanEdit">
							<template slot="no-options">Lokacija ni najdena</template>
						</v-select>
					</b-form-group>
				</b-card>
			</b-col>
		</b-row>
		<b-row v-show="mode === mode_MANAGESTORITVE3">
			<b-col cols=9>
				<b-card>
					<div slot="header">
						Stranka
					</div>
					<div>
						<b-row>
							<b-col cols=1>
								<b-form-group label="External:">
									<b-form-input
										type="text"
										:value="hotel_stranka_selected.external ? 'Da' : 'Ne'"
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group :label="hotel_stranka_selected.is_company ? 'Naziv:' : 'Ime in priimek:'"
									label-for="kupec_ime">
									<b-form-input id="kupec_ime"
										type="text"
										v-model="hotel_stranka_selected.title"
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group label="Email:"
									label-for="kupec_email">
									<b-form-input id="kupec_email"
										type="text"
										v-model="hotel_stranka_selected.email"
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group label="Telefonska številka:" 
									label-for="kupec_telefon">
									<b-form-input id="kupec_telefon"
										type="text"
										v-model="hotel_stranka_selected.phone_number"
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group
									label-for="input-vehicle"
									label="Vozilo:">
										<b-form-input 
										disabled v-model="hotel_stranka_selected.vehicle" id="input-vehicle"></b-form-input>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group
									label-for="input-registration_number"
									label="Registrska številka:">
										<b-form-input
										disabled v-model="hotel_stranka_selected.registration_number" ></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
					</div>
				</b-card>
			</b-col>
			<b-col>
				<b-card>
					<div slot="header">
						Lokacija
					</div>
					<b-form-group
						label-for="input-fk_hotel_lokacija"
						label="Lokacija">
						<b-form-input
							v-model="selectedLocation"
							disabled>
						</b-form-input>
					</b-form-group>
				</b-card>
			</b-col>
		</b-row>
		<b-row v-if="mode === mode_MANAGESTORITVE3">
			<b-col>
				<b-card>
				<loading :active.sync="storitveOfHrambaTable_props.isLoading" 
						:is-full-page="false"></loading>
				<div slot="header">
					<b-row>
						<b-col>
							Storitve <span class="ml-2"></span>
						</b-col>
						<div class="card-actions">
							<b-button v-if="(storitveOfHrambaItems[0] && storitveOfHrambaItems[0].date_take !== null) && userCanEdit" title="Oddaja pnevmatik" ref="hotelHrambaAddGive" class="m-1 seznamHotelStoritveIconStyle" @click.stop="hotelHrambaAddGive_click()" size="sm">
								<i class="fa fa-long-arrow-right"></i>
							</b-button>
						</div>
					</b-row>
				</div>
					<b-table
						ref="hotelStoritveOfHrambaTable"
						responsive="sm"
						striped
						show-empty
						hover
						:empty-text="storitveOfHrambaTable_props.empty_text"
						:empty-filtered-text="storitveOfHrambaTable_props.empty_filtered_text"
						:sort-desc="true"
						:current-page="storitveOfHrambaTable_props.page"
						:per-page="storitveOfHrambaTable_props.size"
						:fields="storitveOfHrambaTable_props.fields"
						:items="getHotelstoritveOfHrambaTable_items"
						@row-clicked="hotelStoritveOfHrambaTable_rowClicked">
						<template slot="dimensions" slot-scope="data">
							{{ getDemensionsLabel(data.item) }}
						</template>
						<template slot="season" slot-scope="data">
							{{ getSeasonLabel(data.item) }}
						</template>
						<template slot="rims" slot-scope="data">
							{{ getRimsLabel(data.item) }}
							<span v-if="data.item.rims_cover === 1 || data.item.rims_screw === 1" :title="getRimsAditionalLabel(data.item)"><i class="fa fa-info-circle"></i></span>
						</template>
						<template slot="date" slot-scope="data">
							<div v-if="data.item.date_take === null">
								<span v-if="data.item.responsible_mechanic_give" :title="'Odgovorni mehanik: ' + data.item.responsible_mechanic_give"> {{ data.item.date_give | hr_date }} </span>
								<span v-else :title="'Odgovorni mehanik ni naveden'"> {{ data.item.date_give | hr_date }} </span>
							</div>
							<div v-else>
								<span v-if="data.item.responsible_mechanic_take" :title="'Odgovorni mehanik: ' + data.item.responsible_mechanic_take"> {{ data.item.date_take | hr_date }} </span>
								<span v-else :title="'Odgovorni mehanik ni naveden'"> {{ data.item.date_take | hr_date }} </span>
							</div>
						</template>
						<template slot="status" slot-scope="data">
							<b-badge :variant="hotelStoritevStatus(data.item).variant" :class="hotelStoritevStatus(data.item).class" :title="hotelStoritevStatus(data.item).title"> {{ hotelStoritevStatus(data.item).label }}</b-badge>
						</template>
						<template slot="last_comment" slot-scope="data">
							<div :title=getHotelComentar(data.item).title> {{ getHotelComentar(data.item).label }}</div>
						</template>
						<template slot="actions" slot-scope="data">
							<b-button v-if="data.item.date_take == null && userCanEdit" variant="success" title="Menjava pnevmatik" ref="hotelHrambaAddSwitch" class="m-1 seznamHotelStoritveIconStyle" @click.stop="hotelHrambaAddSwitch_click(data.item)" size="sm">
								<i class="fa fa-arrows-h"></i>
							</b-button>
							<b-button v-if="data.item.date_take == null && userCanEdit" variant="warning" title="Izdaja pnevmatik" ref="hotelHrambaAddTake" class="m-1 seznamHotelStoritveIconStyle" @click.stop="hotelHrambaAddTake_click(data.item)" size="sm">
								<i class="fa fa-long-arrow-left"></i>
							</b-button>
							<b-button variant="primary" :title="userCanEdit ? 'Uredi storitev' : 'Poglej storitev'" ref="hotelHrambaEdit" class="m-1 seznamHotelStoritveIconStyle" @click.stop="hotelHrambaEdit_click(data.item)" size="sm">
								<i :class="userCanEdit ? 'fa fa-pencil-square-o' : 'fa fa-search-plus'"></i>
							</b-button>
							<b-button :ref="'hotelStoritevPdfExportButton-' + data.item.id" data-style="zoom-in" size="sm" variant="info" title="Prenesi pdf" class="m-1 seznamHotelStoritveIconStyle" @click.stop="exportHotelStoritev(data.item)">
								<i class="fa fa fa-file-pdf-o ladda-label"></i>
							</b-button>
						</template>
					</b-table>
					<nav class="nav">
						<b-row>
							<b-col>
								<b-pagination :total-rows="storitveOfHrambaTable_props.total" :per-page="storitveOfHrambaTable_props.size" v-model="storitveOfHrambaTable_props.page" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
							</b-col>
							<b-col>
								<a class="page-link rows_total">Št. vrstic: {{ storitveOfHrambaTable_props.total }}</a>
							</b-col>
							<b-col>
								<b-form-select v-model="storitveOfHrambaTable_props.size" :options="storitveOfHrambaTable_props.options_numRowsOnPage"></b-form-select>
							</b-col>
						</b-row>
					</nav>
			</b-card>
			</b-col>
		</b-row>
		<div v-if="mode === mode_UNKNOWN0">
			Neznan način
		</div>
		<b-alert :variant="message.type" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<edit-hotel-storitev-modal v-bind:hotelStoritevDistincManufacturers="hotelStoritevDistincManufacturers" ref="editHotelStoritevModal" @emit_success="emit_edit_hotel_storitev"  @emit_comment_added="emit_comment_added_to_hotel_storitev"/>
		<edit-hotel-stranka-modal ref="editHotelStrankaModal" @emit_success="emit_edit_hotel_stranka"/>
		<template slot="modal-footer" slot-scope="{ cancel }">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
						<b-button v-if="userCanEdit" :disabled="okButton.disabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}
							<b-spinner small v-if="okButton.progress"></b-spinner>
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>

<script>
import service from '@/service';
import settings from '@/settings.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as Ladda from 'ladda';
import _ from 'lodash';

import EditHotelStoritevModal from '@/components/HotelGum/Modals/EditHotelStoritevModal';
import EditHotelStrankaModal from '@/components/HotelGum/Modals/EditHotelStrankaModal';

export default {
	name: 'edit-hotel-hramba-modal',
	components: {
		Loading,
		'edit-hotel-storitev-modal': EditHotelStoritevModal,
		'edit-hotel-stranka-modal': EditHotelStrankaModal
	},
	props: {
		hotelStoritevDistincManufacturers: {
			type: Array,
			required: false
		},
		hotelStranke: Array
	},
	methods: {
		showModal: function (mode, hotelHramba) {
			/*
				mode 1 => Dodajanje čisto novega
				mode 2 => Urejanje iz seznama
				mode 3 => Manage storive
			*/
			this.mode = mode;
			this.initModal(hotelHramba);
		},
		initModal: function (hotelHramba) {
			if (this.mode === this.mode_ADDING1) {
				this.title = 'Dodajanje nove hrambe';
				this.okButton.label = 'Dodaj';
			} else if (this.mode === this.mode_EDITING2) {
				this.title = 'Urejanje hrambe št. ' + hotelHramba.id;
				this.hotelHramba = this.initHotelHramba(hotelHramba);
				this.okButton.label = 'Shrani';
			} else if (this.mode === this.mode_MANAGESTORITVE3) {
				this.title = 'Hramba št. ' + hotelHramba.id;
				this.storitveOfHrambaTable_props.inputFilter.fk_hotel_hramba = hotelHramba.id;
				this.hotelHramba = this.initHotelHramba(hotelHramba);
				this.okButton.label = 'Zapri';
			} else {
				this.title = 'Neznan način';
				this.mode = this.mode_UNKNOWN0;
				this.okButton.label = 'Zapri';
			}
			this.$refs.modal.show();
		},
		initHotelHramba: function (hotelHramba) {
			this.hotel_stranka_selected = {
				id: hotelHramba.fk_hotel_stranka,
				first_name: hotelHramba.hotel_stranka_first_name,
				last_name: hotelHramba.hotel_stranka_last_name,
				title: hotelHramba.hotel_stranka_title,
				email: hotelHramba.hotel_stranka_email,
				phone_number: hotelHramba.hotel_stranka_phone_number,
				registration_number: hotelHramba.hotel_stranka_registration_number,
				vehicle: hotelHramba.hotel_stranka_vehicle,
				external: hotelHramba.hotel_stranka_external,
				is_company: hotelHramba.hotel_stranka_is_company
			};
			this.selectedLocation = hotelHramba.hotel_lokacija_title;
			return {
				id: hotelHramba.id,
				fk_hotel_stranka: hotelHramba.fk_hotel_stranka,
				fk_hotel_lokacija: hotelHramba.fk_hotel_lokacija
			};
		},
		onOkModal: function () {
			if (this.formDisabled) {
				this.$emit('emit_success', this.hotelHramba, this.mode, this.manageMode_actionCommited);
				this.$refs.modal.hide();
			} else {
				this.startProgress();
				this.showAlert();
				if (this.hotelHramba.fk_hotel_lokacija === -1) {
					let hotelLokacija = {
						id: -1,
						title: this.selectedLocation
					};
					service.hotelLokacijaEdit(hotelLokacija)
						.then(responseData => {
							if (responseData.message === 'edited' || responseData.message === 'added' || responseData.message === 'alreadyExists') {
								this.hotelHramba.fk_hotel_lokacija = responseData.hotelLokacija.id;
								this.hotelHrambaEdit();
							} else {
								this.showAlert('Neveljaven odziv strežnika pri dodajanju lokacije!', this.ALERT_TYPE_ERROR);
								console.error('Neveljaven response message: ' + responseData.message);
								this.stopProgress();
							}
						})
						.catch(error => {
							this.stopProgress();
							if (error.response) {
							// Request made and server responded
								if (error.response.status === 400) {
									if (error.response.data.internalCode === 600) {
										this.showAlert('Neznana napaka na strežniku (lokacija)!', this.ALERT_TYPE_ERROR);
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 601) {
										this.showAlert('Napaka pri podatkovni bazi (lokacija)!', this.ALERT_TYPE_ERROR);
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 602) {
										this.showAlert('Uporabnik nima dostopa do hotela gum (lokacija)!', this.ALERT_TYPE_ERROR);
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 603) {
										this.showAlert('Napaka pri validaciji na strežniku pri dodajanju lokacije (lokacija)!', this.ALERT_TYPE_ERROR);
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 605) {
										this.showAlert('Neuspešno shranjevanje lokacije (lokacija)!', this.ALERT_TYPE_ERROR);
										console.error(error.response.data.message);
									} else {
										this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ') (lokacija)!', this.ALERT_TYPE_ERROR);
										console.error(error.response.data.internalCode, error.response.data.message);
									}
								} else {
									this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ') (lokacija)!', this.ALERT_TYPE_ERROR);
									console.error(error.response.status, error.response.data.message);
								}
							} else if (error.request) {
								// The request was made but no response was received
								this.showAlert('Napaka: strežnik se ni odzval (lokacija)!', this.ALERT_TYPE_ERROR);
								console.error('The request was made but no response was received:', error.request);
							} else {
								// Something happened in setting up the request that triggered an Error
								this.showAlert('Napaka pri pošiljanju zahteve na strežnik (lokacija)!', this.ALERT_TYPE_ERROR);
								console.error('Something happened in setting up the request that triggered an Error:', error.message);
							}
						});
				} else {
					this.hotelHrambaEdit();
				}
			}
		},
		hotelHrambaEdit: function () {
			service.hotelHrambaEdit(this.hotelHramba)
				.then(responseData => {
					if (responseData.message === 'edited' || responseData.message === 'added') {
						this.$emit('emit_success', responseData.hotelHramba, this.mode, this.manageMode_actionCommited);
						this.$refs.modal.hide();
					} else {
						this.showAlert('Neveljaven odziv strežnika (hramba)!', this.ALERT_TYPE_ERROR);
						console.error('Neveljaven response message: ' + responseData.message);
					}
					this.stopProgress();
				})
				.catch(error => {
					this.stopProgress();
					if (error.response) {
					// Request made and server responded
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								this.showAlert('Neznana napaka na strežniku (hramba)!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								this.showAlert('Napaka pri podatkovni bazi (hramba)!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								this.showAlert('Uporabnik nima dostopa do hotela gum (hramba)!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								this.showAlert('Napaka pri validaciji na strežniku (hramba)!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 604) {
								this.showAlert('Hramba ni najdena!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 605) {
								this.showAlert('Neuspešno shranjevanje hrambe (hramba)!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else {
								this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ') (hramba)!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ') (hramba)!', this.ALERT_TYPE_ERROR);
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						this.showAlert('Napaka: strežnik se ni odzval (hramba)!', this.ALERT_TYPE_ERROR);
						console.error('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						this.showAlert('Napaka pri pošiljanju zahteve na strežnik (hramba)!', this.ALERT_TYPE_ERROR);
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		clearModalData: function () {
			if (this.mode === this.mode_MANAGESTORITVE3) {
				this.storitveOfHrambaTable_props.empty_text = '';
				this.storitveOfHrambaTable_props.empty_filtered_text = 'Ni zadetkov';
				this.storitveOfHrambaTable_props.page = 1;
				this.storitveOfHrambaTable_props.size = 5;
				this.storitveOfHrambaTable_props.total = 0;
				this.storitveOfHrambaTable_props.isLoading = false;
				this.storitveOfHrambaTable_props.inputFilter.fk_hotel_hramba = null;
				this.storitveOfHrambaTable_props.inputFilter.with_archived = true;
				this.storitveOfHrambaTable_props.inputFilter.textFilterTimeout = null;
			}
			this.title = '';
			this.stopProgress();
			this.showAlert();
			this.okButton.label = '';
			this.mode = this.mode_UNKNOWN0;
			this.hotelHramba = {
				id: 0,
				fk_hotel_stranka: null,
				fk_hotel_lokacija: null
			};
			this.manageMode_actionCommited = false;
			this.clearHotelStranka();
			this.selectedLocation = null;
			this.hotelStranke_searched = null;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		showHotelStoritveOfHrambaTable: function () {
			this.collapseHotelStoritveOfHrambaTableIcon = 'fa fa-chevron-up';
		},
		hideHotelStoritveOfHrambaTable: function () {
			this.collapseHotelStoritveOfHrambaTableIcon = 'fa fa-chevron-down';
		},
		hotelHrambaAddGive_click: function () {
			let modalInput = {
				mode: 1,
				hotelStoritev: null,
				hotelHramba: this.hotelHramba
			}
			this.$refs.editHotelStoritevModal.showModal(modalInput); // Add new give to HotelHramba
		},
		hotelHrambaAddTake_click: function (item) {
			let modalInput = {
				mode: 2,
				hotelStoritev: item,
				hotelHramba: this.hotelHramba
			}
			this.$refs.editHotelStoritevModal.showModal(modalInput); // Add new give to HotelHramba
		},
		hotelHrambaAddSwitch_click: function (item) {
			let modalInput = {
				mode: 3,
				hotelStoritev: item,
				hotelHramba: this.hotelHramba
			}
			this.$refs.editHotelStoritevModal.showModal(modalInput); // Add new switch to HotelHramba
		},
		hotelHrambaEdit_click: function (item) {
			let modalInput = {
				mode: 4,
				hotelStoritev: item,
				hotelHramba: this.hotelHramba
			}
			this.$refs.editHotelStoritevModal.showModal(modalInput); // Edit storitev of HotelHramba
		},
		emit_edit_hotel_storitev: function (storitev, mode) {
			if (mode === 1) { // addGive
				this.showAlert('Gume  #' + storitev.id + ' uspešno oddane.', this.ALERT_TYPE_SUCCESS, 3);
				this.$emit('emit_hotelStoritev_changed');
				this.manageMode_actionCommited = true;
				this.$refs.hotelStoritveOfHrambaTable.refresh();
			} else if (mode === 2) { // addTake
				this.showAlert('Gume  #' + storitev.id + ' uspešno izdane.', this.ALERT_TYPE_SUCCESS, 3);
				this.$emit('emit_hotelStoritev_changed');
				this.manageMode_actionCommited = true;
				this.$refs.hotelStoritveOfHrambaTable.refresh();
				// this.$emit('emit_success', this.hotelHramba, this.mode, this.manageMode_actionCommited);
				// this.$refs.modal.hide();
			} else if (mode === 3) { // addSwitch
				this.showAlert('Zamenjava dodana.', this.ALERT_TYPE_SUCCESS, 3);
				this.$emit('emit_hotelStoritev_changed');
				this.manageMode_actionCommited = true;
				this.$refs.hotelStoritveOfHrambaTable.refresh();
			} else if (mode === 4) { // editing
				this.showAlert('Storitev #' + storitev.id + ' urejena.', this.ALERT_TYPE_SUCCESS, 3);
				this.$emit('emit_hotelStoritev_changed');
				this.manageMode_actionCommited = true;
				this.$refs.hotelStoritveOfHrambaTable.refresh();
			} else { // neznana akcija
				this.showAlert('Neznana akcija.', this.ALERT_TYPE_ERROR, 3);
				console.error('Neznana akcija emit_edit_hotel_storitev', storitev, mode);
			}
		},
		emit_comment_added_to_hotel_storitev: function () {
			this.$emit('emit_hotelStoritev_changed');
			this.$refs.hotelStoritveOfHrambaTable.refresh();
		},
		getHotelstoritveOfHrambaTable_items: function (ctx) {
			this.storitveOfHrambaTable_props.isLoading = true;
			return service.getHotelStoritveFiltered(ctx, this.storitveOfHrambaTable_props.inputFilter)
				.then(responseData => {
					this.storitveOfHrambaTable_props.isLoading = false;
					if (responseData.message === 'success') {
						this.storitveOfHrambaTable_props.empty_text = 'Ni vnosov';
						this.storitveOfHrambaTable_props.total = responseData.items.total;
						this.storitveOfHrambaItems = responseData.items.data;
						return responseData.items.data;
					} else {
						this.showAlert('Neznana odziv strežnika!', this.ALERT_TYPE_ERROR);
						this.storitveOfHrambaTable_props.empty_text = 'Napaka pri pridobivanju storitev hrambe';
						this.storitveOfHrambaTable_props.total = 0;
						console.error('Neveljaven odziv strežnika: ', responseData.message);
						this.storitveOfHrambaItems = [];
						return [];
					}
				})
				.catch(error => {
					this.storitveOfHrambaTable_props.isLoading = false;
					if (error.response) {
					// Request made and server responded
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								this.showAlert('Neznana napaka na strežniku!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								this.showAlert('Napaka pri podatkovni bazi!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								this.showAlert('Uporabnik nima dostopa do hotela gum!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								this.showAlert('Napaka pri validaciji na strežniku!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 604) {
								this.showAlert('Hramba ni najdena!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 605) {
								this.showAlert('Neuspešno shranjevanje hrambe!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else {
								this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', this.ALERT_TYPE_ERROR);
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', this.ALERT_TYPE_ERROR);
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						this.showAlert('Napaka: strežnik se ni odzval!', this.ALERT_TYPE_ERROR);
						console.error('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						this.showAlert('Napaka pri pošiljanju zahteve na strežnik!', this.ALERT_TYPE_ERROR);
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		getDemensionsLabel: function (item) {
			let dimensions = JSON.parse(item.dimensions);
			return dimensions.width + '/' + dimensions.heigth + 'R' + dimensions.diameter;
		},
		getSeasonLabel: function (item) {
			let selectedOption = settings.season_options.find(element => element.value === item.season);
			if (selectedOption) {
				return selectedOption.text;
			}
			return '';
		},
		getRimsLabel: function (item) {
			let selectedOption = settings.rims_options.find(element => element.value === item.rims);
			if (selectedOption) {
				return selectedOption.text;
			}
			return '';
		},
		getRimsAditionalLabel: function (item) {
			let label = '';
			if (item.rims_cover === 1 && item.rims_screw === 1) {
				label = 'S pokrovi in vijaki';
			} else if (item.rims_cover === 1) {
				label = 'S pokrovi';
			} else if (item.rims_screw === 1) {
				label = 'Z vijaki';
			}
			return label;
		},
		hotelStoritevStatus: function (item) {
			if (item.date_take && item.fk_hotel_storitev_give) {
				let title = 'Gume so bile zamenjane z gumami #' + item.fk_hotel_storitev_give + ' dne ' + this.$options.filters.hr_date(item.date_take);
				if (item.fk_hotel_storitev_take) {
					title += '\nDodane pa so bile kot zamenjava za gume #' + item.fk_hotel_storitev_take + ' dne ' + this.$options.filters.hr_date(item.date_give);
				}
				return {
					label: 'Zamenjane',
					variant: 'warning',
					class: '',
					title: title
				}
			} else if (item.date_take) {
				return {
					label: 'Prevzete',
					variant: 'danger',
					class: '',
					title: 'Gume so bile prevzete dne ' + this.$options.filters.hr_date(item.date_take)
				}
			} else if (item.fk_hotel_storitev_take) {
				return {
					label: 'Zamenjane',
					variant: 'success',
					class: '',
					title: 'Gume so bile oddane v skladišče dne ' + this.$options.filters.hr_date(item.date_give) + ' kot zamenjava za gume #' + item.fk_hotel_storitev_take
				}
			} else {
				return {
					label: 'Oddane',
					variant: 'success',
					class: '',
					title: 'Gume so bile oddane v skladišče dne ' + this.$options.filters.hr_date(item.date_give)
				}
			}
		},
		exportHotelStoritev: function (item) {
			this.showAlert();
			let loader = Ladda.create(this.$refs['hotelStoritevPdfExportButton-' + item.id]);
			loader.start();
			service.exportHotelStoritev(item.id)
				.then(response => {
					loader.stop();
					const fileLink = document.createElement('a');
					fileLink.href = URL.createObjectURL(response.data);
					fileLink.setAttribute('download', response.headers['content-disposition'].split('filename=')[1]);
					fileLink.click();
					URL.revokeObjectURL(fileLink.href);
				})
				.catch(error => {
					loader.stop();
					if (error.response) {
					// Request made and server responded
						this.showAlert('Napaka pri prenosu pdf-a!', this.ALERT_TYPE_ERROR);
					} else if (error.request) {
						// The request was made but no response was received
						this.showAlert('Napaka pri prenosu pdf-a: strežnik se ni odzval!', this.ALERT_TYPE_ERROR);
						console.error('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						this.showAlert('Napaka pri pošiljanju zahteve za prenos pdf-a na strežnik!', this.ALERT_TYPE_ERROR);
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		initializeHotelLokacijeOptions: function () {
			service.searchHotelLokacije({qs: '#initialize', freeOnly: false})
				.then(hotelLokacije => {
					this.hotelLokacije_initOptions = hotelLokacije;
					this.hotelLokacije_searched = hotelLokacije;
				})
				.catch(error => {
					this.hotelLokacije_initOptions = [];
					this.hotelLokacije_searched = [];
					if (error.response) {
						// Request made and server responded
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								console.error(error.response.data.message);
							} else {
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						console.error('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		hotelLokacijeSelect_load: _.debounce((loading, search, vm) => {
			if (!vm.hotelLokacije_searchEmpty) {
				service.searchHotelLokacije({qs: search, freeOnly: false})
					.then(hotelLokacije => {
						loading(false);
						vm.hotelLokacije_searched = hotelLokacije;
					})
					.catch(error => {
						loading(false);
						if (error) {
							console.log(error);
						}
					});
			} else {
				loading(false);
			}
		}, 500),
		hotelLokacijeSelect_change: function (hotelLokacija) {
			if (hotelLokacija && hotelLokacija.id) {
				this.hotelHramba.fk_hotel_lokacija = hotelLokacija.id;
				this.selectedLocation = hotelLokacija.title;
			} else if (hotelLokacija) {
				this.selectedLocation = hotelLokacija;
				this.hotelHramba.fk_hotel_lokacija = -1;
			} else {
				if (this.hotelHramba.fk_hotel_lokacija !== -1) {
					this.hotelHramba.fk_hotel_lokacija = null;
					this.hotelLokacije_searched = [...this.hotelLokacije_initOptions];
				}
			}
		},
		hotelLokacijeSelect_search: function (search, loading) {
			this.hotelLokacijeSelect_change(search);
			if (search && search !== '') {
				this.hotelLokacije_searchEmpty = false;
				loading(true);
				this.hotelLokacijeSelect_load(loading, search, this);
			} else if (search === '' && this.hotelHramba.fk_hotel_lokacija == null) {
				this.hotelLokacije_searched = [...this.hotelLokacije_initOptions];
				this.hotelLokacije_searchEmpty = true;
			}
		},
		load_hotelStranke: function () {
			this.hotelStranke_options = [];
			service.searchHotelStranke('#initialize')
				.then(hotelStranke => {
					this.hotelStranke_options = hotelStranke;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		hotelStrankeSelect_load: _.debounce((loading, search, vm) => {
			if (!vm.hotelStranke_searchEmpty) {
				service.searchHotelStranke(search)
					.then(hotelStranke => {
						loading(false);
						vm.hotelStranke_searched = hotelStranke;
					})
					.catch(error => {
						loading(false);
						if (error) {
							console.log(error);
						}
					});
			} else {
				loading(false);
			}
		}, 500),
		hotelStrankeSelect_change (hotelStranka) {
			if (hotelStranka) {
				this.hotel_stranka_selected = hotelStranka;
				this.hotelHramba.fk_hotel_stranka = hotelStranka.id;
			} else {
				this.hotelStranke_searched = null;
				this.hotelHramba.fk_hotel_stranka = null;
				this.clearHotelStranka();
			}
		},
		hotelStrankeSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.hotelStranke_searchEmpty = false;
				loading(true);
				this.hotelStrankeSelect_load(loading, search, this);
			} else if (search === '' && this.hotel_stranka_selected == null) {
				this.hotelStranke_searched = null;
				this.hotelStranke_searchEmpty = true;
			}
		},
		hotelStrankaAdding_click: function () {
			let modalInput = {
				mode: 1,
				hotelStranka: null
			}
			this.$refs.editHotelStrankaModal.showModal(modalInput); // Add new hotelStranka
		},
		hotelStrankaEdit_click: function () {
			let modalInput = {
				mode: 2,
				hotelStranka: this.hotel_stranka_selected
			}
			this.$refs.editHotelStrankaModal.showModal(modalInput); // Add new hotelStranka
		},
		emit_edit_hotel_stranka: function (hotelStranka, mode) {
			if (mode === 1) { // adding
				this.all_hotelStranke.push(hotelStranka);
				this.hotel_stranka_selected = hotelStranka;
				this.hotelHramba.fk_hotel_stranka = hotelStranka.id;
				this.$emit('emit_hotelStranke_changed');
				// this.showAlert('Stranka  #' + storitev.id + ' uspešno dodana.', this.ALERT_TYPE_SUCCESS, 3);
			} else if (mode === 2) { // editing
				this.hotel_stranka_selected = hotelStranka;
				this.hotelHramba.fk_hotel_stranka = hotelStranka.id;
				this.$emit('emit_hotelStranke_changed');
				// this.showAlert('Stranka #' + hotelStranka.id + ' uspešno urejena.', this.ALERT_TYPE_SUCCESS, 3);
			} else { // neznana akcija
				this.showAlert('Neznana akcija pri urejanju stranke.', this.ALERT_TYPE_ERROR, 3);
				console.error('Neznana akcija emit_edit_hotel_stranka', hotelStranka, mode);
			}
		},
		clearHotelStranka: function () {
			this.hotel_stranka_selected = {
				id: 0,
				first_name: '',
				last_name: '',
				title: '',
				email: '',
				phone_number: '',
				address: '',
				city: '',
				registration_number: '',
				vehicle: '',
				external: 1,
				is_company: 0
			}
		},
		hotelStoritveOfHrambaTable_rowClicked: function (item, index) {
			this.hotelHrambaEdit_click(item);
		},
		getHotelComentar: function (item) {
			if (item.hotel_komentarji.length > 0) {
				let tmpLabel = '';
				if (item.hotel_komentarji[0].content == null) {
					tmpLabel = '';
				} else if (item.hotel_komentarji[0].content.length > 70) {
					tmpLabel += item.hotel_komentarji[0].content.substring(0, 70);
					tmpLabel += '...';
				} else {
					tmpLabel = item.hotel_komentarji[0].content;
				}
				return {
					label: tmpLabel,
					title: item.hotel_komentarji[0].content
				}
			} else {
				return {
					label: ' / ',
					title: 'Ni komentarjev'
				}
			}
		}
	},
	data: function () {
		return {
			manageMode_actionCommited: false,
			isLoading: false,
			title: '',
			okButton: {
				label: '',
				progress: false,
				disabled: false
			},
			hotelStrankaEditButoon: {
				label: 'Uredi',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_ADDING1: 1,
			mode_EDITING2: 2,
			mode_MANAGESTORITVE3: 3,
			mode: 0,
			hotelHramba: {
				id: 0,
				fk_hotel_lokacija: null,
				fk_hotel_stranka: null
			},
			storitveOfHrambaTable_props: {
				fields: [
					{ key: 'id', label: '#', sortable: true, class: '' },
					{ key: 'num_tires', label: 'Št. gum', sortable: true, class: 'tdHotelStoritveStGum' },
					{ key: 'manufacturer', label: 'Znamka', sortable: true, class: '' },
					{ key: 'dimensions', label: 'Dimenzije', sortable: false, class: '' },
					{ key: 'season', label: 'Sezona', sortable: true, class: '' },
					{ key: 'rims', label: 'Platišča', sortable: true, class: '' },
					{ key: 'date', label: 'Datum storitve', filsortable: true, class: 'tdHotelStoritveDatum' },
					{ key: 'last_comment', label: 'Zadnji komentar', filsortable: true, class: 'tdLastHotelKomentar' },
					{ key: 'status', label: 'Status', sortable: false, class: 'tdHotelStoritveStatus' },
					{ key: 'actions', label: '', sortable: false, class: 'tdHotelStoritveActions' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				page: 1,
				size: 5,
				total: 0,
				isLoading: false,
				inputFilter: {
					fk_hotel_hramba: null,
					with_archived: true
				},
				textFilterTimeout: null,
				options_numRowsOnPage: [
					{ value: 5, text: '5' },
					{ value: 10, text: '10' },
					{ value: 50, text: '50' }
				]
			},
			storitveOfHrambaItems: [],
			external_options: [
				{ text: 'External', value: 1 },
				{ text: 'Internal', value: 0 }
			],
			hotelLokacije_searched: [],
			hotelLokacije_initOptions: [],
			hotelLokacije_searchEmpty: false,
			selectedLocation: null,
			hotelStranke_searchEmpty: false,
			hotel_stranka_selected: {
				id: 0,
				first_name: '',
				last_name: '',
				title: '',
				email: '',
				phone_number: '',
				address: '',
				city: '',
				registration_number: '',
				vehicle: '',
				external: 1,
				is_company: 0
			},
			hotelStranke_options: null,
			hotelStranke_searched: null,
			hotelStranka_adding: false,
			hotelStranka_editing: false
		}
	},
	watch: {
	},
	computed: {
		formDisabled: function () {
			if (this.mode === this.mode_MANAGESTORITVE3 || this.mode === this.mode_UNKNOWN0) {
				return true;
			}
			return false;
		},
		modalSize () {
			if (this.mode === this.mode_ADDING1 || this.mode === this.mode_EDITING2) {
				return 'md';
			} else if (this.mode === this.mode_MANAGESTORITVE3) {
				return 'huge';
			}
			return '';
		},
		hotelLokacije_options () {
			if (this.hotelLokacije_searched.length !== 0) {
				return this.hotelLokacije_searched;
			} else if (this.hotelLokacije_initOptions.length === 0) {
				this.initializeHotelLokacijeOptions();
				return this.hotelLokacije_initOptions;
			}
		},
		all_hotelStranke () {
			if (this.hotelStranke_searched != null) {
				return this.hotelStranke_searched;
			} if (this.hotelStranke) {
				return this.hotelStranke;
			} else {
				if (this.hotelStranke_options == null) {
					this.load_hotelStranke();
				}
				return this.hotelStranke_options;
			}
		},
		stranka_card_cols () {
			if (this.mode === this.mode_ADDING1 || this.mode === this.mode_EDITING2) {
				return 12;
			} else {
				return 4;
			}
		},
		feedback_lokacija () {
			if (this.hotelHramba.fk_hotel_lokacija === -1) {
				return 'Lokacija se bo samodejno dodala.';
			}
			return '';
		},
		state_lokacija () {
			if (this.hotelHramba.fk_hotel_lokacija === -1) {
				return true;
			}
			return false;
		},
		user () {
			return this.$store.getters.user;
		},
		userCanEdit () {
			if (settings.isModerator(this.user.role) || settings.isAdmin(this.user.role) || settings.isSkrbnikGum(this.user.role)) {
				return true;
			} else {
				return false;
			}
		}
	},
	created () {
	}
}
</script>

<style scoped>
@import '../../../../node_modules/ladda/dist/ladda-themeless.min.css';
.ma_pos {
	text-align: end;
}
.nav {
	border-top: 1px solid #c8ced3;
	padding-top: 1rem;
}
.pagination {
	margin-left: 1rem;
	margin-right: 1rem;
}
.page-link.rows_total {
	text-align: center;
	border-radius: 5px;
	width: 120px;
}
.noPointer {
	cursor: default
}
</style>
<style>
.seznamHotelStoritveIconStyle {
	min-width: 35px;
}
.tdHotelStoritveActions {
	width: 200px;
	max-width: 200px;
	padding: 2px !important;
	text-align: end;
}
.tdHotelStoritveStatus {
	width: 70px;
}
.tdHotelStoritveDatum {
	width: 160px;
}
.tdLastHotelKomentar {
	max-height: 20px;
	max-width: 130px;
}
.tdHotelStoritveLetnik {
	width: 100px;
}
.tdHotelStoritveStGum {
	width: 100px;
}
.tdHotelStoritveId {
	width: 50px;
}
@media (min-width: 992px) { .modal .modal-huge { max-width: 90% !important; width: 90% !important;; } }
</style>


// WEBPACK FOOTER //
// src/components/HotelGum/Modals/EditHotelHrambaModal.vue